import { Card, Typography } from 'antd'
import { VideoPlayer as SharedVideoPlayer } from '@suntex.fim/ui'

import { useVideoParams } from '../hooks/useVideoParams'

const { Title } = Typography

function VideoPlayer() {
  const { mediaId, friendlyName, height, width } = useVideoParams()

  return (
    <div style={{ maxWidth: 960, margin: '0 auto', padding: 24 }}>
      <Card
        variant="outlined"
        style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', padding: 24 }}
      >
        <Title level={3} style={{ textAlign: 'center' }}>
          {friendlyName}
        </Title>
        <div
          style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}
        >
          <SharedVideoPlayer mediaId={mediaId} height={height} width={width} />
        </div>
      </Card>
    </div>
  )
}

export default VideoPlayer
